











































































import Card from '@/components/UI/Card.vue';
import OmnichannelIndividualParamsModal
  from '@/pages/omnichannel-strategy/tabs/products/OmnichannelIndividualParamsModal.vue';
import OmnichannelStrategyApi from '@/pages/omnichannel-strategy/api/OmnichannelStrategyApi';
import {IOmnichannelStrategyFilters, IOmnichannelStrategyTableDto,} from '@/pages/omnichannel-strategy/types/data';
import {
  IProductListFilter,
  IProductListBaseParams, IProductListItem
} from '@/pages/omnichannel-strategy/types/product-list';
import {FindFiltersParams} from '@/interfaces/global-data';
import {CategoryStrategies, OmnichannelStrategy} from '@/interfaces/server-data';
import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';
import {FormatNumber} from '@/numberFormatter';
import { Formatter } from '@/helpers/formatters';
import {Component, Mixins, Prop} from 'vue-property-decorator';
import UploadWithErrorsBlock from '@/components/UI/UploadWithErrorsBlock.vue';

@Component({
  components: {
    UploadWithErrorsBlock,
    Card,
    OmnichannelIndividualParamsModal,
  },
})
export default class OmnichannelProductsList extends Mixins(LocalData, Http) {
  @Prop({type: Object, default: () => null}) readonly selectedStrategy!: IOmnichannelStrategyTableDto | null;
  @Prop({type: Object, required: true}) readonly filters!: IOmnichannelStrategyFilters;

  private api: OmnichannelStrategyApi = new OmnichannelStrategyApi({parent: this});
  private skuFilter: string = '';
  private skuList: IProductListItem[] = [];
  private isPageTableLoading: boolean = false;
  private isDownloadLoading: boolean = false;
  private errorsAmount: number = 0;
  private tableFilterSignature: string = '';
  private selectedStrategyFilters: string[] = [];
  private selectedGroupFilters: number[] = [];
  private selectedCategoryFilters: number[] = [];
  private selectedSubcategoryFilters: number[] = [];
  private selectedStoreFormatFilters: number[] = [];
  private selectedStoreRegionFilters: number[] = [];
  private selectedStoreClusterFilters: number[] = [];
  pagination = {
    current: 1,
    pageSize: 10,
    total: 0
  }

  private numberFormatter = (v: any): string => FormatNumber.format(v);

  private get hasTradingId(): boolean {
    const id = this.tradingId;
    return id != null && id > 0;
  }

  private get tradingId(): number | null {
    const selectedStrategyTradingId = this.selectedStrategy && this.selectedStrategy.tradingNetId;
    if (selectedStrategyTradingId != null && selectedStrategyTradingId > 0) {
      return selectedStrategyTradingId;
    }

    return this.filters && this.filters.market && this.filters.market.id > 0
      ? this.filters.market.id
      : null;
  }

  private normalizeFilterValue(value: number | null | undefined): number | null {
    return value != null && value > 0 ? value : null;
  }

  private formatYesNo(value: any): string {
    return value != null ? (value ? this.$tc('shared.actions.yes') : this.$tc('shared.actions.no')) : '';
  }

  private formatFixedGapType(value: any): string {
    if (value == null) return '';
    const key = `omnichannelStrategy.fixedGapTypes.${value}`;
    const translated = this.$tc(key);
    return translated !== key ? translated : String(value);
  }

  private formatStrategy(value: any): string {
    if (value == null) return '';
    const key = `omnichannelStrategy.strategies.${value}`;
    const translated = this.$tc(key);
    return translated !== key ? translated : String(value);
  }

  private formatDate(value: any): string {
    return value ? new Date(value).toLocaleDateString() : '';
  }

  private getNestedValue(record: any, path: string[]): string {
    const value = path.reduce((acc, key) => (acc == null ? null : acc[key]), record);
    return value == null ? '' : String(value);
  }

  private getNestedId(record: any, path: string[]): number | null {
    const parent = path.slice(0, -1).reduce((acc, key) => (acc == null ? null : acc[key]), record);
    const id = parent && parent.id;
    return typeof id === 'number' && id > 0 ? id : null;
  }

  private buildTagFilters(path: string[]): Array<{ text: string; value: string }> {
    const byId = new Map<number, string>();
    this.skuList.forEach((item) => {
      const id = this.getNestedId(item, path);
      const name = this.getNestedValue(item, path);
      if (id != null && name !== '') {
        byId.set(id, name);
      }
    });
    return Array.from(byId.entries())
      .sort((a, b) => a[1].localeCompare(b[1]))
      .map(([id, name]) => ({ text: name, value: String(id) }));
  }

  private buildTextFilters(path: string[]): Array<{ text: string; value: string }> {
    return Array.from(new Set(
      this.skuList
        .map((item) => this.getNestedValue(item, path))
        .filter((value) => value !== '')
    ))
      .sort((a, b) => a.localeCompare(b))
      .map((value) => ({ text: value, value }));
  }

  private filterByNestedText(value: string, record: any, path: string[]): boolean {
    return this.getNestedValue(record, path) === value;
  }

  private get strategyFilterOptions(): Array<{ text: string; value: string }> {
    return [
      { text: this.formatStrategy(OmnichannelStrategy.PRICE_EQUALITY), value: OmnichannelStrategy.PRICE_EQUALITY },
      { text: this.formatStrategy(OmnichannelStrategy.FIXED_DIFFERENCE), value: OmnichannelStrategy.FIXED_DIFFERENCE },
      { text: this.formatStrategy(OmnichannelStrategy.OPTIMAL_DIFFERENCE_ML), value: OmnichannelStrategy.OPTIMAL_DIFFERENCE_ML },
    ];
  }

  private toStringArray(value: any): string[] {
    return Array.isArray(value) ? value.map((item) => String(item)) : [];
  }

  private toNumberArray(value: any): number[] {
    return this.toStringArray(value)
      .map((item) => Number(item))
      .filter((item) => !Number.isNaN(item) && item > 0);
  }

  private get tableColumns(): any[] {
    return [
    { dataIndex: 'internalCode', title: this.$tc('omnichannelStrategy.products.columns.internalCode'), width: 100 },
    { dataIndex: 'skuName', title: this.$tc('omnichannelStrategy.products.columns.skuName'), width: 170, ellipsis: true },
    {
      dataIndex: 'strategy',
      title: this.$tc('omnichannelStrategy.products.columns.strategy'),
      width: 120,
      customRender: (value: any) => (value ? this.formatStrategy(value) : '-'),
      ellipsis: true,
      key: 'strategy',
      filters: this.strategyFilterOptions,
      filteredValue: this.selectedStrategyFilters,
    },
    {
      dataIndex: 'fixedGapType',
      title: this.$tc('omnichannelStrategy.products.columns.gap'),
      width: 90,
      customRender: (value: any) => (value ? this.formatFixedGapType(value) : '-'),
      scopedSlots: { filterDropdown: 'fixedGapType', },
    },
    {
      dataIndex: 'gap',
      title: this.$tc('omnichannelStrategy.products.columns.gapPercent'),
      width: 90,
      customRender: (value: any) => (value != null ? String(value) : '-'),
      scopedSlots: { filterDropdown: 'gap',},
    },
    {
      dataIndex: 'considerCompetitivePricing',
      title: this.$tc('omnichannelStrategy.products.columns.considerCompetitivePricing'),
      width: 180,
      customRender: (value: any) => this.formatYesNo(value),
      scopedSlots: { filterDropdown: 'considerCompetitivePricingFilter' },
    },
    {
      dataIndex: 'minProfitabilityLimit',
      title: this.$tc('omnichannelStrategy.products.columns.minProfitabilityLimit'),
      width: 220,
      customRender: (value: any) => value != null ? this.formatYesNo(value) : '-',
      scopedSlots: { filterDropdown: 'minProfitabilityLimitFilter'},
    },
    {
      dataIndex: 'remains',
      title: this.$tc('omnichannelStrategy.products.columns.remains'),
      width: 70,
      customRender: (value: any) => (value !== null && value !== undefined) ? String(value) : '-',
    },
    {
      dataIndex: 'expiration',
      title: this.$tc('omnichannelStrategy.products.columns.expiration'),
      width: 100,
      scopedSlots: { customRender: 'expirationField' },
    },
    {
      dataIndex: 'group.name',
      title: this.$tc('omnichannelStrategy.products.columns.productGroup'),
      width: 150,
      ellipsis: true,
      key: 'group',
      filters: this.buildTagFilters(['group', 'name']),
      filteredValue: this.selectedGroupFilters.map(String),
    },
    {
      dataIndex: 'category.name',
      title: this.$tc('omnichannelStrategy.products.columns.productCategory'),
      width: 150,
      ellipsis: true,
      key: 'category',
      filters: this.buildTagFilters(['category', 'name']),
      filteredValue: this.selectedCategoryFilters.map(String),
    },
    {
      dataIndex: 'subcategory.name',
      title: this.$tc('omnichannelStrategy.products.columns.productSubcategory'),
      width: 170,
      ellipsis: true,
      key: 'subcategory',
      filters: this.buildTagFilters(['subcategory', 'name']),
      filteredValue: this.selectedSubcategoryFilters.map(String),
    },
    {
      dataIndex: 'storeFormat.name',
      title: this.$tc('omnichannelStrategy.products.columns.format'),
      width: 120,
      ellipsis: true,
      key: 'storeFormat',
      filters: this.buildTagFilters(['storeFormat', 'name']),
      filteredValue: this.selectedStoreFormatFilters.map(String),
    },
    {
      dataIndex: 'storeRegion.name',
      title: this.$tc('omnichannelStrategy.products.columns.region'),
      width: 120,
      ellipsis: true,
      key: 'storeRegion',
      filters: this.buildTagFilters(['storeRegion', 'name']),
      filteredValue: this.selectedStoreRegionFilters.map(String),
    },
    {
      dataIndex: 'storeCluster.name',
      title: this.$tc('omnichannelStrategy.products.columns.cluster'),
      width: 120,
      ellipsis: true,
      key: 'storeCluster',
      filters: this.buildTagFilters(['storeCluster', 'name']),
      filteredValue: this.selectedStoreClusterFilters.map(String),
    },
    { dataIndex: 'productSegmentName', title: this.$tc('omnichannelStrategy.products.columns.productSegments'), width: 120, ellipsis: true },
    { dataIndex: 'keyCharacteristicOfTheProductIsOne', title: this.$tc('omnichannelStrategy.products.columns.kht1'), width: 120, ellipsis: true },
    { dataIndex: 'keyCharacteristicOfTheProductIsTwo', title: this.$tc('omnichannelStrategy.products.columns.kht2'), width: 120, ellipsis: true },
    { dataIndex: 'recipeAttribute', title: this.$tc('omnichannelStrategy.products.columns.prc'), width: 120, ellipsis: true },
    { dataIndex: 'treatmentAttribute', title: this.$tc('omnichannelStrategy.products.columns.pkl'), width: 120, ellipsis: true },
    {
      dataIndex: 'kvi',
      title: 'KVI',
      width: 80,
      customRender: (value: any) => this.formatYesNo(value),
    },
    { dataIndex: 'tagsKvi', title: this.$tc('omnichannelStrategy.products.columns.kviTags'), width: 100 },
    { dataIndex: 'ctm', title: this.$tc('omnichannelStrategy.products.columns.ctm'), width: 70, ellipsis: true },
    { dataIndex: 'productRange', title: this.$tc('omnichannelStrategy.products.columns.productRange'), width: 130, ellipsis: true },
    {
      dataIndex: 'lastPrice',
      title: this.$tc('omnichannelStrategy.products.columns.lastPrice'),
      width: 130,
      customRender: (value: any) => (value ? this.numberFormatter(value) : '-'),
    },
    {
      dataIndex: 'priceSegment',
      title: this.$tc('omnichannelStrategy.products.columns.priceSegment'),
      width: 150,
      ellipsis: true,
      customRender: (value: any, row: any) =>
        [row.priceSegmentMin, row.priceSegmentMax].some((v) => v != null)
          ? `${row.priceSegmentMin != null ? this.numberFormatter(row.priceSegmentMin) : ''} - ${row.priceSegmentMax != null ? this.numberFormatter(row.priceSegmentMax) : ''}`
          : '-',
    },
    {
      dataIndex: 'lastPriceMarginPc',
      title: this.$tc('omnichannelStrategy.products.columns.lastPriceMargin'),
      width: 150,
      ellipsis: true,
      customRender: (value: any) => this.numberFormatter(value),
    },
    {
      dataIndex: 'actualProfitability',
      title: this.$tc('omnichannelStrategy.products.columns.actualProfitability'),
      width: 120,
      ellipsis: true,
      customRender: (value: any) => this.numberFormatter(value),
    },
    {
      dataIndex: 'purchasePriceAvgM',
      title: this.$tc('omnichannelStrategy.products.columns.avgPurchasePrice'),
      width: 100,
      ellipsis: true,
      customRender: (value: any) => this.numberFormatter(value),
    },
    { dataIndex: 'coefficentList', title: this.$tc('omnichannelStrategy.products.columns.priceOptStrategy'), width: 200, ellipsis: true },
    { dataIndex: 'priceIncreaseLimit', title: this.$tc('omnichannelStrategy.products.columns.priceIncreaseLimit'), width: 150 },
    { dataIndex: 'periodPriceIncreaseLimit', title: this.$tc('omnichannelStrategy.products.columns.periodPriceIncreaseLimit'), width: 160 },
    { dataIndex: 'period', title: this.$tc('omnichannelStrategy.products.columns.period'), width: 80 },
    { dataIndex: 'marginalProfit', title: this.$tc('omnichannelStrategy.products.columns.minProfitabilitySku'), width: 150 },
    { dataIndex: 'maxMarginalProfit', title: this.$tc('omnichannelStrategy.products.columns.maxProfitabilitySku'), width: 150 },
    { dataIndex: 'kviStrategy', title: this.$tc('omnichannelStrategy.products.columns.kviStrategy'), width: 130, ellipsis: true },
    { dataIndex: 'percentageOfCompetitorsPrice', title: this.$tc('omnichannelStrategy.products.columns.correction'), width: 100 },
    {
      dataIndex: 'productVolume',
      title: this.$tc('omnichannelStrategy.products.columns.vgh'),
      width: 40,
      customRender: (value: any) => this.numberFormatter(value),
    },
    { dataIndex: 'measurementUnit', title: this.$tc('omnichannelStrategy.products.columns.measurementUnit'), width: 35 },
    { dataIndex: 'productVerticalLine', title: this.$tc('omnichannelStrategy.products.columns.vlName'), width: 75, ellipsis: true },
    {
      dataIndex: 'isVerticalLineBase',
      title: this.$tc('omnichannelStrategy.products.columns.baseProduct'),
      width: 60,
      customRender: (value: any) => this.formatYesNo(value),
    },
    { dataIndex: 'vlStrategyStr', title: this.$tc('omnichannelStrategy.products.columns.vlStrategy'), width: 75 },
    {
      dataIndex: 'vlGapPc',
      title: this.$tc('omnichannelStrategy.products.columns.vlGapPercent'),
      width: 140,
      customRender: (_value: any, record: any) => Formatter.vlGap(record.vlGapPc, record.vlGapType),
    },
    ];
  }

  private onSearch() {
    this.pagination.current = 1;
    this.fetchSkuList();
  }

  private onTableChange(pagination: any, filters: any) {
    const signature = JSON.stringify(filters || {});
    const filtersChanged = signature !== this.tableFilterSignature;
    this.tableFilterSignature = signature;
    this.selectedStrategyFilters = this.toStringArray(filters && filters.strategy);
    this.selectedGroupFilters = this.toNumberArray(filters && filters.group);
    this.selectedCategoryFilters = this.toNumberArray(filters && filters.category);
    this.selectedSubcategoryFilters = this.toNumberArray(filters && filters.subcategory);
    this.selectedStoreFormatFilters = this.toNumberArray(filters && filters.storeFormat);
    this.selectedStoreRegionFilters = this.toNumberArray(filters && filters.storeRegion);
    this.selectedStoreClusterFilters = this.toNumberArray(filters && filters.storeCluster);
    this.pagination.current = filtersChanged ? 1 : pagination.current;
    this.pagination.pageSize = pagination.pageSize;
    this.fetchSkuList();
  }

  private clearFilterInUpperPanel() {
    this.skuFilter = '';
    this.pagination.current = 1;
    this.fetchSkuList();
  }

  private getStrategyProductFilter(): IProductListBaseParams | null {
    const s = this.selectedStrategy;
    const tradingId = this.tradingId;
    if (tradingId == null) {
      return null;
    }

    if (!s) {
      const groupOfProduct = this.normalizeFilterValue(this.filters.groupOfProduct);
      const category = this.normalizeFilterValue(this.filters.categoryOfProduct);
      const subcategory = this.normalizeFilterValue(this.filters.subcategory);
      const storeFormat = this.normalizeFilterValue(this.filters.formatSelected);
      const storeRegion = this.normalizeFilterValue(this.filters.regionSelected);
      const storeCluster = this.normalizeFilterValue(this.filters.clusterSelected);

      return {
        tradingId,
        groupOfProduct,
        groupsOfProduct: groupOfProduct != null ? [groupOfProduct] : null,
        category,
        categories: category != null ? [category] : null,
        subcategories: subcategory != null ? [subcategory] : null,
        storeFormat,
        storeRegionValues: storeRegion != null ? [storeRegion] : null,
        storeCluster,
        storeClusters: storeCluster != null ? [storeCluster] : null,
      };
    }

    return {
      tradingId,
      groupOfProduct: s.groupOfProduct ? s.groupOfProduct.id : null,
      groupsOfProduct: s.groupOfProduct ? [s.groupOfProduct.id] : null,
      category: s.productCategory ? s.productCategory.id : null,
      categories: s.productCategory ? [s.productCategory.id] : null,
      subcategories: s.subcategory && s.subcategory.id != null ? [s.subcategory.id] : null,
      storeFormat: s.dependStoreParams && s.dependStoreParams.format ? s.dependStoreParams.format.id : null,
      storeRegionValues: s.dependStoreParams && s.dependStoreParams.region ? [s.dependStoreParams.region.id] : null,
      storeCluster: s.dependStoreParams && s.dependStoreParams.cluster ? s.dependStoreParams.cluster.id : null,
      storeClusters: s.dependStoreParams && s.dependStoreParams.cluster ? [s.dependStoreParams.cluster.id] : null,
    };
  }

  private buildProductListFilterParams(): IProductListFilter | null {
    const base = this.getStrategyProductFilter();
    if (!base) return null;

    return {
      ...base,
      calculationDepth: 4,
      calculationDay: 28,
      seasonValues: [],
      buyerSegments: [],
      productSegments: null,
      skuFilter: this.skuFilter || '',
      discountPrise: false,
      promo: false,
      kvi: 2,
      kviCartIdFilter: -1,
      needCalculateSku: false,
      saleIdFilter: -1,
      onlyWithOmnichannelIndividualStrategy: this.selectedStrategy == null,
      omnichannelStrategies: this.selectedStrategyFilters,
      productListGroupIds: this.selectedGroupFilters,
      productListCategoryIds: this.selectedCategoryFilters,
      productListSubcategoryIds: this.selectedSubcategoryFilters,
      productListStoreFormatIds: this.selectedStoreFormatFilters,
      productListStoreRegionIds: this.selectedStoreRegionFilters,
      productListStoreClusterIds: this.selectedStoreClusterFilters,
    } as IProductListFilter;
  }

  private fetchSkuList() {
    const filter = this.buildProductListFilterParams();
    if (!filter) {
      this.skuList = [];
      this.pagination.total = 0;
      return;
    }
    this.isPageTableLoading = true;
    const pageSize = this.pagination.pageSize || 10;
    const current = this.pagination.current || 1;
    const offset = (current - 1) * pageSize;
    this.api
      .fetchProductList(filter, { limit: pageSize, offset })
      .then((res) => {
        const content = res.data.content || [];
        const total = res.data.totalElements;
        this.pagination.total = total;
        this.skuList = content.map((row: any) => ({
          ...row,
          fixedGapType: row.fixedGapType,
          strategy: row.strategy,
          gap: row.gap,
          applyCompetitorPrices: row.applyCompetitorPrices,
          considerCompetitivePricing: row.applyCompetitorPrices,
          minProfitabilityLimit: row.minProfitabilityLimit,
        }));
      })
      .catch(() => {
        this.skuList = [];
        this.pagination.total = 0;
      })
      .finally(() => {
        this.isPageTableLoading = false;
      });
  }

  private buildIndividualFilterParams(): FindFiltersParams | null {
    const base = this.getStrategyProductFilter();
    if (!base) return null;

    const params = new FindFiltersParams();
    params.categoryStrategy = CategoryStrategies.EMPTY;
    params.productSegments = null;
    params.tradingId = base.tradingId;
    params.groupOfProduct = base.groupOfProduct;
    params.groupsOfProduct = base.groupsOfProduct;
    params.category = base.category;
    params.categories = base.categories;
    params.subcategories = base.subcategories;
    params.storeFormat = base.storeFormat;
    params.storeRegionValues = base.storeRegionValues;
    params.storeCluster = base.storeCluster;
    return params;
  }

  private downloadProductList() {
    const params = this.buildIndividualFilterParams();
    if (!params) return;
    this.isDownloadLoading = true;
    this.api
      .downloadProductListExcel(params)
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.$tc('omnichannelStrategy.messages.productsFilename'));
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {})
      .finally(() => {
        this.isDownloadLoading = false;
      });
  }

  private getErrorsAmount() {
    const id = this.tradingId;
    if (id == null) return;
    this.api.getLastFileErrorsAmount(id, 'OMNICHANNEL_INDIVIDUAL_FILTERS').then((r) => {
      this.errorsAmount = r.data;
    });
  }

  private downloadErrors() {
    const id = this.tradingId;
    if (id == null) {
      this.showError(this.$tc('omnichannelStrategy.messages.selectStrategy'));
      return;
    }

    this.api.getOmnichannelStrategiesIndividualImportErrors(id)
      .then((response) => {
        if (!response.data || (typeof response.data === 'string' && !response.data.trim())) {
          this.showInfo(this.$tc('omnichannelStrategy.messages.noErrors'));
          return;
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.$tc('omnichannelStrategy.messages.importErrorsFilename'));
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      });
  }

  private uploadWithFileForComponent(file: File): Promise<void> {
    const id = this.tradingId;
    if (id == null) {
      return Promise.reject(new Error(this.$tc('omnichannelStrategy.messages.selectStrategy')));
    }
    const uploadFile = new FormData();
    uploadFile.append('file', new Blob([file]), file.name);
    return this.api.uploadOmnichannelStrategiesIndividualFile(id, uploadFile).then(() => {});
  }

  private getUploadStatusForComponent(): Promise<{ status: string; progress?: number }> {
    const id = this.tradingId;
    if (id == null) {
      return Promise.reject(new Error(this.$tc('omnichannelStrategy.messages.noTradingCampaign')));
    }
    return this.api.getOmnichannelStrategiesIndividualUploadStatus(id).then((res) => ({
      status: res.data.status,
      progress: res.data.progress != null ? res.data.progress : undefined,
    }));
  }

  private fetchAllData() {
    this.fetchSkuList();
    this.getErrorsAmount();
  }
}
